<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Product </h1>
            </div>
            <div class="global-main">
                <form id="companyForm" @submit.prevent="addProduct">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> SKU <em class="required">*</em></label>
                            <input v-model="form.sku" type="text" name="sku" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('sku') }">
                            <has-error :form="form" field="sku"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Name <em class="required">*</em></label>
                            <input v-model="form.name" type="text" name="name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Description <em class="required">*</em></label>
                            <textarea v-model="form.description" name="description" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('description') }"></textarea>
                            <has-error :form="form" field="description"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Price <em class="required">*</em></label>
                            <input v-model="form.price" type="text" name="price" @keypress="isNumber($event)" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('price') }">
                            <has-error :form="form" field="price"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Discount </label>
                            <input v-model="form.discount" type="text" name="discount" @keypress="isNumber($event)" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('discount') }">
                            <has-error :form="form" field="discount"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/priceList" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    sku : '',
                    name : '',
                    description : '',
                    price : '',
                    discount : '',
                }),
                wholesaler: null,
            }
        },
        methods: {
            addProduct() {
                this.$Progress.start();
                this.form.post('api/addProduct')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Product added successfully');
                        this.$router.push('/priceList');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>